<template>
	<v-app>
		<v-main>
			<router-view />
		</v-main>
	</v-app>
</template>

<script>
export default {
	name: "App",

	data: () => ({
		//
	}),
};
</script>

<style>
* {
	font-family: Raleway;
}
#app {
	background-color: rgba(229, 35, 34, 0.1);
}
@font-face {
	font-family: Megatron;
	src: url("../font/Megatron.otf");
}

@font-face {
	font-family: Raleway;
	src: url("../font/Raleway-Medium.ttf");
}

/* ── Design global des tableaux ── */

.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
	background: #f9fafb !important;
	color: #6b7280 !important;
	font-size: 0.72rem !important;
	font-weight: 600 !important;
	text-transform: none !important;
	letter-spacing: 0 !important;
	font-family: Montserrat, sans-serif !important;
	border-bottom: 1px solid #e5e7eb !important;
	padding: 12px 16px !important;
	white-space: nowrap;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th .v-icon {
	font-size: 14px !important;
	color: #9ca3af !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
	font-size: 0.83rem !important;
	color: #111827 !important;
	font-family: Montserrat, sans-serif !important;
	border-bottom: 1px solid #f3f4f6 !important;
	padding: 13px 16px !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td {
	border-bottom: none !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__expanded__content):hover > td {
	background: #f9fafb !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr.v-data-table__selected > td {
	background: #eff6ff !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr.v-data-table__expanded__content > td {
	padding: 0 !important;
	border-bottom: 1px solid #e5e7eb !important;
	background: #fafafa !important;
}

.v-data-table .v-data-table__progress th {
	padding: 0 !important;
	height: auto !important;
}

.v-data-footer {
	border-top: 1px solid #e5e7eb !important;
	font-family: Montserrat, sans-serif !important;
	font-size: 0.75rem !important;
	color: #6b7280 !important;
}

.v-data-footer .v-data-footer__select .v-select__selection--comma,
.v-data-footer .v-data-footer__pagination,
.v-data-footer .v-data-footer__select .v-label {
	font-size: 0.75rem !important;
	font-family: Montserrat, sans-serif !important;
	color: #6b7280 !important;
}

.v-data-footer .v-btn.v-btn--icon {
	color: #9ca3af !important;
}

.v-data-footer .v-btn.v-btn--icon:not([disabled]):hover {
	color: #111827 !important;
	background: #f3f4f6 !important;
}
</style>
